module.exports = __webpack_public_path__ + "static/media/0_2019_07_04.f24ef7fc.jpg";